<button ds-button kind="primary" variant="filled" size="large" truncate="true" [disabled]="!value || !!btnerror" (click)="submitAutoCashout()">
    {{ btnText }}
</button>
